export function Alarm({
  width = 24,
  height = 24,
  className = '',
}: {
  width?: number;
  height?: number;
  className?: string;
}) {
  return (
    <svg
      width={width}
      height={height}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      className={className}
    >
      <g clipPath="url(#clip0_86_8941)">
        <path
          d="M7.88 3.38938L6.595 1.85938L2 5.71438L3.285 7.24437L7.88 3.38938ZM22 5.71937L17.405 1.86437L16.12 3.39437L20.715 7.24937L22 5.71937ZM11.995 3.99937C7.02 3.99937 3 8.02938 3 12.9994C3 17.9694 7.02 21.9994 11.995 21.9994C16.97 21.9994 21 17.9694 21 12.9994C21 8.02938 16.97 3.99937 11.995 3.99937ZM12 19.9994C8.135 19.9994 5 16.8644 5 12.9994C5 9.13438 8.135 5.99937 12 5.99937C15.865 5.99937 19 9.13438 19 12.9994C19 16.8644 15.87 19.9994 12 19.9994ZM13 8.99937H11V11.9994H8V13.9994H11V16.9994H13V13.9994H16V11.9994H13V8.99937Z"
          fill="white"
        />
      </g>
      <defs>
        <clipPath id="clip0_86_8941">
          <rect width="24" height="24" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Alarm;
